import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { authenticationService } from "./services/AuthinticationService";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./assets/Fonts/fonts.css";

const queryClient = new QueryClient();

let isAuthenticated = authenticationService.isLoggedin();
if (isAuthenticated) authenticationService.reauthenticate();

// --- Disable all React red error overlays (development only) ---
if (process.env.NODE_ENV === "development") {
  window.addEventListener("error", (event) => {
    event.preventDefault(); // Block the red error overlay
    console.error("Suppressed runtime error:", event.error);
  });

  window.addEventListener("unhandledrejection", (event) => {
    event.preventDefault(); // Block promise rejection overlay
    console.error("Suppressed unhandled promise rejection:", event.reason);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App /> {/* UI will keep running even if errors happen */}
    </BrowserRouter>
  </QueryClientProvider>
);

reportWebVitals();
